import { render } from "./LoanCalculator.vue?vue&type=template&id=52c11744&scoped=true"
import script from "./LoanCalculator.vue?vue&type=script&lang=js"
export * from "./LoanCalculator.vue?vue&type=script&lang=js"

import "./LoanCalculator.vue?vue&type=style&index=0&id=52c11744&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c11744"]])

export default __exports__